export default __webpack_public_path__ + "static/media/210430-Cloudxier Clients Logo-23.9aac7f1a.png";